<template>
  <div id="pcBottom" class="bottom" style="min-width:1600px;">
    <p>Copyright © {{ year }} 上海帆扬宇亿科技有限公司 AII rights reserved</p>
    <p>
      沪ICP备2024062463号-2
      <!-- <img src="../assets/images/upload.png" /> -->
    </p>
  </div>
</template>

<script>
export default {
  name: "bottom",
  data() {
    return {
      year: "",
    };
  },
  mounted() {
    this.year = new Date().getFullYear();
  },
  methods: {
  },
};
</script>
<style scoped>
.bottom {
  position: absolute;
  background: #141623;
  width: 100%;
  color: #fff;
  font-size: 16px;
  padding: 18px 0;
  padding-top: 25px;
  padding-bottom: 26px;
  box-sizing: border-box;
  z-index: 999;
}
.bottom p {
  display: flex;
  align-items: center;
  justify-content: center;
}
.bottom p:first-child {
  margin-bottom: 12px;
}
.bottom p img {
  margin-right: 10px;
}
.bottom .title {
  font-size: 20px;
  margin-right: 54px;
}
.title1 {
  margin-right: 30px;
}
.bottom p:last-child {
  margin-top: 6px;
}
.bottom p:last-child img {
  margin-left: 20px;
  margin-right: 20px;
}
</style>
